// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.milestones-section {
  position: relative;
  padding: 80px 20px;

  /* border-radius: 30px; */
  text-align: center;
  overflow: hidden;
  z-index: 1;
}

/* Yellow bubble on left */
.milestones-section::before {
  content: "";
  position: absolute;
  left: -0px;
  top: 40%;
  width: 80px;
  height: 80px;
  background-color: #ffefcc; /* soft yellow */
  border-radius: 50%;
  z-index: 0;
}


/* Purple-orange gradient at bottom right */
.milestones-section::after {
  content: "";
  position: absolute;
  bottom: -80px;
  right: -80px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle at center, #ffa500 0%, #8000ff 100%);
  opacity: 0.15;
  border-radius: 50%;
  z-index: 0;
}

/* Ensure content floats above background elements */
.milestones-header,
.milestones-grid {
  position: relative;
  z-index: 2;
}

.milestones-header h2 {
  font-size: 35px;
  margin-bottom: 10px;
  font-weight: 700;
  color: #222;
}

.milestones-header p {
  font-size: 1.1rem;
  color: #555;
  font-weight: 500;
}

.milestones-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-top: 40px;
}

.milestone-card {
  background: #fff;
  border-radius: 15px;
  padding: 20px;
  width: 400px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.milestone-icon {
  
  padding: 10px;
  border-radius: 50%;
  margin-bottom: 15px;
}

.milestone-card h3 {
  font-size: 1.25rem;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.milestone-card p {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 12px;
  text-align: center;
}

.milestone-card span {
  font-weight: bold;
  font-size: 0.9rem;
  color: #2d4f42;
}

/* Responsive */
@media (max-width: 768px) {
  .milestone-card {
    width: 100%;
    max-width: 100%;
  }

}
/* Responsive */
@media (max-width: 1024px) {
  .milestones-grid {
    justify-content: center; /* keep cards centered */
  }

  .milestone-card {
    width: 48%;   /* 2 cards per row on tablets */
    max-width: none;
  }
}

@media (max-width: 768px) {
  .milestones-grid {
    flex-direction: column; /* stack cards */
    align-items: stretch;   /* full width */
    gap: 20px;
  }

  .milestone-card {
    width: 100% !important;   /* full width */
    max-width: 100% !important;
    padding: 18px;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Milestones.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB;EAClB,UAAU;AACZ;;;AAGA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uEAAuE;EACvE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oDAAoD;AACpD;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;AACA,eAAe;AACf;EACE;IACE,uBAAuB,EAAE,wBAAwB;EACnD;;EAEA;IACE,UAAU,IAAI,+BAA+B;IAC7C,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,gBAAgB;IACxC,oBAAoB,IAAI,eAAe;IACvC,SAAS;EACX;;EAEA;IACE,sBAAsB,IAAI,eAAe;IACzC,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".milestones-section {\r\n  position: relative;\r\n  padding: 80px 20px;\r\n\r\n  /* border-radius: 30px; */\r\n  text-align: center;\r\n  overflow: hidden;\r\n  z-index: 1;\r\n}\r\n\r\n/* Yellow bubble on left */\r\n.milestones-section::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -0px;\r\n  top: 40%;\r\n  width: 80px;\r\n  height: 80px;\r\n  background-color: #ffefcc; /* soft yellow */\r\n  border-radius: 50%;\r\n  z-index: 0;\r\n}\r\n\r\n\r\n/* Purple-orange gradient at bottom right */\r\n.milestones-section::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -80px;\r\n  right: -80px;\r\n  width: 300px;\r\n  height: 300px;\r\n  background: radial-gradient(circle at center, #ffa500 0%, #8000ff 100%);\r\n  opacity: 0.15;\r\n  border-radius: 50%;\r\n  z-index: 0;\r\n}\r\n\r\n/* Ensure content floats above background elements */\r\n.milestones-header,\r\n.milestones-grid {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.milestones-header h2 {\r\n  font-size: 35px;\r\n  margin-bottom: 10px;\r\n  font-weight: 700;\r\n  color: #222;\r\n}\r\n\r\n.milestones-header p {\r\n  font-size: 1.1rem;\r\n  color: #555;\r\n  font-weight: 500;\r\n}\r\n\r\n.milestones-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: 30px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.milestone-card {\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  padding: 20px;\r\n  width: 400px;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.milestone-icon {\r\n  \r\n  padding: 10px;\r\n  border-radius: 50%;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.milestone-card h3 {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 10px;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.milestone-card p {\r\n  font-size: 0.95rem;\r\n  color: #666;\r\n  margin-bottom: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.milestone-card span {\r\n  font-weight: bold;\r\n  font-size: 0.9rem;\r\n  color: #2d4f42;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .milestone-card {\r\n    width: 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n}\r\n/* Responsive */\r\n@media (max-width: 1024px) {\r\n  .milestones-grid {\r\n    justify-content: center; /* keep cards centered */\r\n  }\r\n\r\n  .milestone-card {\r\n    width: 48%;   /* 2 cards per row on tablets */\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .milestones-grid {\r\n    flex-direction: column; /* stack cards */\r\n    align-items: stretch;   /* full width */\r\n    gap: 20px;\r\n  }\r\n\r\n  .milestone-card {\r\n    width: 100% !important;   /* full width */\r\n    max-width: 100% !important;\r\n    padding: 18px;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
